import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';

import {
  AuthorizeGuard,
  AnonymousGuard,
  AuthService,
  ErrorPageGuard,
  AuthInterceptor,
  AccountService,
  AuthHelpers,
  LegalService,
  ToastService,
  AlertService,
  VerificationTimerService,
  VerificationConfirmService,
  VerificationResendService,
  ResetPasswordGuard,
  PendingVerificationGuard
} from './services';
import { LoaderInterceptor, LoaderService } from './services/loader';
import { UnauthorizedInterceptor } from './services/auth/interceptors/unauthorized';
import {
  DashboardTourBuilder,
  ProfileTourBuilder,
  TOUR_BUILDERS,
  TourIntentGuard,
  TourIntentService,
  TourService
} from './tours';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    AuthService,
    AuthHelpers,
    AccountService,
    LoaderService,
    LegalService,
    ToastService,
    AlertService,
    VerificationTimerService,
    VerificationConfirmService,
    VerificationResendService,
    TourService,
    TourIntentService,
    TourIntentGuard,
    AuthorizeGuard,
    AnonymousGuard,
    ResetPasswordGuard,
    PendingVerificationGuard,
    ErrorPageGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
    { provide: TOUR_BUILDERS, multi: true, useClass: DashboardTourBuilder },
    { provide: TOUR_BUILDERS, multi: true, useClass: ProfileTourBuilder }
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error(
        `${parentModule} has already been loaded. Import Core modules in the AppModule only.`
      );
    }
  }
}
